import { render, staticRenderFns } from "./new-nfse.vue?vue&type=template&id=2f981560&scoped=true&"
import script from "./new-nfse.vue?vue&type=script&lang=js&"
export * from "./new-nfse.vue?vue&type=script&lang=js&"
import style0 from "./new-nfse.vue?vue&type=style&index=0&id=2f981560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f981560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VTextField})
